import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "cascader"
  }, [_c('div', {
    staticClass: "clearfix white-bg"
  }, _vm._l(_vm.crumbs, function (name, index) {
    return _c('div', {
      key: index,
      staticClass: "cascader__crumb",
      "class": {
        selected: _vm.level == index
      },
      style: {
        color: _vm.level === index ? _vm.color : ''
      },
      on: {
        "click": function click($event) {
          return _vm.onClickCrumb(index);
        }
      }
    }, [_vm._v(" " + _vm._s(name) + " ")]);
  }), 0), _c('div', {
    staticClass: "cascader__level"
  }, _vm._l(_vm.list, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "cascader__item after-line",
      "class": {
        selected: item.id == _vm.value[_vm.level]
      },
      on: {
        "click": function click($event) {
          return _vm.onClickItem(item, _vm.level);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };